import { render, staticRenderFns } from "./RivileSearch.vue?vue&type=template&id=c60980a6&scoped=true&"
import script from "./RivileSearch.vue?vue&type=script&lang=js&"
export * from "./RivileSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60980a6",
  null
  
)

export default component.exports